import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import { Styled } from './style'

interface IProps {
  type?: 'button' | 'submit'
  label?: string | JSX.Element
  variant?: 'primary' | 'secondary'
  size?: 'sm'
  disabled?: boolean
  action: Function
  fullWidth?: boolean
  testId?: string
}

const Button: FunctionComponent<IProps> = ({
  type = 'button',
  label = 'Button',
  variant = 'primary',
  disabled = false,
  size,
  action,
  fullWidth = false,
  testId,
}) => {
  return (
    <Styled.Button
      onClick={(e: React.SyntheticEvent<HTMLElement>) => {
        if (action) return action(e)
      }}
      className={classNames(
        'buttonHoverBg',
        variant,
        size,
        fullWidth ? 'full-width' : ''
      )}
      disabled={disabled}
      type={type}
      data-testid={testId || `button-${variant}`}
    >
      {label}
    </Styled.Button>
  )
}

export default Button
